import { useContext } from "react";
import { BaseBenefitsList } from "@/components/BaseComponents/BaseBenefitsList";
import { BaseColumnInformation } from "@/components/BaseComponents/BaseColumnInformation";
import { BaseCompanyLogo } from "@/components/BaseComponents/BaseCompanyLogo";
import BaseCompanyName from "@/components/BaseComponents/BaseCompanyName";
import BaseCouponDescription from "@/components/BaseComponents/BaseCouponDescription";
import BaseGridRatingHorizontal from "@/components/BaseComponents/BaseGridRatingHorizontal";
import BaseLinkWrapper from "@/components/BaseComponents/BaseLinkWrapper";
import BaseReviewLink from "@/components/BaseComponents/BaseReviewLink";
import BaseServiceFlag from "@/components/BaseComponents/BaseServiceFlag";
import { BaseTrustpilotReview } from "@/components/BaseComponents/BaseTrustpilotReview";
import { BaseVisitLink } from "@/components/BaseComponents/BaseVisitLink";
import { CompanyContext } from "@/components/CompanyList/CompanyContext";
import { getAwardText } from "@/selectors";
import { useSelector } from "react-redux";

import { PhoneLink } from "./PhoneLink";
import { getStyles } from "./styles";
import {
	DEFAULT_LINK_TEXT,
	ThemeContext,
	TRUSTPILOT_REVIEW_WIDGET,
	WEB_REVIEW_WIDGET,
} from "./ThemeContext";

export const FavyColumns = () => {
	const { company } = useContext(CompanyContext);
	const {
		linkText = DEFAULT_LINK_TEXT,
		reviewWidget = null,
		rendersCoupon = false,
		rendersPhoneLink = false,
	} = useContext(ThemeContext);
	const awardText = useSelector((state) => getAwardText(state, { company }));
	const styles = getStyles({ awardText });

	return (
		<div className={`tw:relative tw:[border-top:1px_solid_#e5e7eb]`}>
			<div className="tw:bg-white">
				<div className="tw:relative tw:mx-auto tw:mt-4 tw:flex tw:max-w-[500px] tw:flex-col tw:desktop:max-w-none tw:desktop:flex-row">
					<BaseServiceFlag classNames={styles.serviceFlag} />

					<div
						className={`tw:flex tw:w-full tw:px-4 tw:pt-4 tw:desktop:w-[240px] tw:desktop:items-center tw:desktop:justify-center tw:desktop:px-0 tw:desktop:pt-0 tw:lg:w-[260px] tw:lg2:w-[284px]`}
					>
						<BaseLinkWrapper
							className={`tw:flex tw:w-full tw:flex-col tw:items-center`}
						>
							<BaseCompanyLogo classNames={styles.companyLogo} />

							{reviewWidget === TRUSTPILOT_REVIEW_WIDGET && (
								<BaseTrustpilotReview classNames={styles.trustpilotReview} />
							)}
							{reviewWidget === WEB_REVIEW_WIDGET && (
								<BaseGridRatingHorizontal classNames={styles.rating} />
							)}
						</BaseLinkWrapper>
					</div>

					<div className="tw:flex tw:flex-col tw:items-center tw:justify-center tw:p-4 tw:desktop:flex-row tw:desktop:px-0">
						<div className="tw:flex tw:w-full tw:max-w-[340px] tw:flex-col tw:desktop:max-w-none tw:desktop:flex-row">
							<BaseLinkWrapper>
								<BaseCompanyName className="tw:mb-4 tw:text-xl tw:leading-6 tw:font-bold tw:text-gray-900" />
								<BaseBenefitsList
									{...styles.benefitsList}
									isExpandable={true}
									mobileItemsToShow={2}
								/>
							</BaseLinkWrapper>

							<BaseLinkWrapper className="tw:mt-4 tw:flex tw:w-full tw:items-center tw:desktop:mt-0 tw:desktop:w-[240px] tw:lg2:w-[286px]">
								<BaseColumnInformation classNames={styles.columnInformation} />
							</BaseLinkWrapper>
						</div>
					</div>
					<div className="tw:mb-5 tw:flex tw:w-full tw:flex-col tw:items-center tw:justify-center tw:px-8 tw:desktop:mb-0 tw:desktop:flex-1 tw:desktop:px-2 tw:lg:px-3 tw:lg2:px-4">
						{rendersPhoneLink && (
							<PhoneLink className="tw:relative tw:inline-flex tw:h-[40px] tw:w-[190px] tw:items-center tw:justify-center tw:rounded-full tw:bg-[#38a169] tw:text-sm tw:font-bold tw:text-white tw:hover:bg-[#2f855a] tw:desktop:w-full tw:desktop:max-w-[190px]" />
						)}

						<BaseLinkWrapper className="tw:relative tw:inline-flex tw:h-[40px] tw:w-[190px] tw:items-center tw:justify-evenly tw:rounded-full tw:bg-[#38a169] tw:text-sm tw:font-bold tw:text-white tw:hover:bg-[#2f855a] tw:desktop:w-full tw:desktop:max-w-[190px]">
							<BaseVisitLink>{linkText}</BaseVisitLink>
						</BaseLinkWrapper>

						{rendersCoupon && (
							<BaseLinkWrapper>
								<BaseCouponDescription classNames={styles.couponDescription} />
							</BaseLinkWrapper>
						)}

						<BaseReviewLink
							classNames={styles.reviewLink}
							linkText="Read Review"
						/>
					</div>
				</div>
			</div>
		</div>
	);
};
